import { useCallback, useEffect, useState } from 'react';
import { ENDPOINTS } from 'site-constants';

import { httpRequest } from '@candu-ai/commons/network';

interface UserTrait {
  name: string;
  traitType: 'String' | 'Boolean' | 'Number';
}

export const useUserTraits = () => {
  const [data, setData] = useState<UserTrait[] | undefined>(undefined);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const endpoint = `${ENDPOINTS.autoComplete}?finder=byUserTraits`;

  const fetchUserTraits = useCallback(async () => {
    try {
      const rawResponse = await httpRequest(endpoint);
      const parsed = await rawResponse.json();
      setData(parsed);
      setLoading(false);
    } catch (e) {
      setError(true);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUserTraits();
  }, [fetchUserTraits]);

  return {
    loading,
    data,
    error,
  };
};
